/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react'
import { Modal } from 'antd'
import Loader from 'react-loader-spinner'
import AuthService from '../../../services/AuthService'
import './SendByMailModal.scss'

const Auth = new AuthService()

const SendByMailModal = (props) => {
  const { isOpen, toggle, email, color } = props

  const [status, setStatus] = useState('waiting')

  const sendByMail = () => {
    setStatus('loading')

    Auth.fetch('/lambda-interaction', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sendLinkByEmail: true,
        email,
        link: window.location.href,
      }),
    })
      .then((res) => {
        const { success } = res

        if (success) {
          setStatus('sent')
        } else {
          setStatus('failed')
        }
      })
      .catch((err) => {
        console.error(err)
        setStatus('failed')
      })
  }

  let content = ''

  if (status === 'waiting') {
    content = (
      <span>
        Vous allez recevoir votre lien de candidature par mail à l'adresse{' '}
        <strong>{email}</strong> pour que vous puissiez la reprendre quand vous
        le souhaitez.
      </span>
    )
  } else if (status === 'sent') {
    content = (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="sa">
          <div className="sa-success">
            <div className="sa-success-tip" />
            <div className="sa-success-long" />
            <div className="sa-success-placeholder" />
            <div className="sa-success-fix" />
          </div>
        </div>
        <span>
          Un mail vous a été envoyé à l'adresse <strong>{email}</strong> avec
          votre lien de candidature.
        </span>
      </div>
    )
  } else if (status === 'failed') {
    content = (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className="sa">
          <div className="sa-error">
            <div className="sa-error-x">
              <div className="sa-error-left" />
              <div className="sa-error-right" />
            </div>
            <div className="sa-error-placeholder" />
            <div className="sa-error-fix" />
          </div>
        </div>
        <span>
          Un erreur a été rencontrée lors de l'envoi de votre lien de
          candidature à l'adresse <strong>{email}</strong>.
        </span>
      </div>
    )
  } else if (status === 'loading') {
    content = (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Loader type="TailSpin" color={color} height={100} width={100} />
      </div>
    )
  }

  return (
    <Modal
      visible={isOpen}
      toggle={toggle}
      okText="Envoyer"
      cancelText="Annuler"
      okButtonProps={{
        disabled: status !== 'waiting',
      }}
      onOk={sendByMail}
      onCancel={toggle}
      title="Envoyer le lien de candidature par email"
    >
      {content}
    </Modal>
  )
}

export default SendByMailModal
